const warmedVariantImages = new Set();

function warmVariantImage(target, priority = 'low') {
  const label = target.closest?.('[data-variant-image-url]');
  const url = label?.dataset.variantImageUrl;

  if (!url || warmedVariantImages.has(url)) return;
  warmedVariantImages.add(url);

  const image = new Image();
  image.decoding = 'async';
  image.fetchPriority = priority;
  image.src = url;
}

document.addEventListener('pointerover', (event) => warmVariantImage(event.target));
document.addEventListener('focusin', (event) => warmVariantImage(event.target));
document.addEventListener('pointerdown', (event) => warmVariantImage(event.target, 'high'));
